import React, {PropsWithChildren, useContext} from 'react';
import { VehicleCategory } from '@vw-marketing/vw-ca-types';
import {ResultsViewContext} from '../utils/results-view-context';
import {getEVIncentives} from '../utils/get-ev-incentives';
import {VehicleContext} from '../utils/vehicle-context';
import VehicleDetail from '../components/VehicleCard/VehicleDetail';
import {StyledCard} from '../styles/vehicle-card';
import { VehicleData } from '../types';

interface Props extends PropsWithChildren {
  vehicle: VehicleData;
};

const VehicleCardLayout: React.FC<Props> = ({children, vehicle}) => {
  const view = useContext(ResultsViewContext).value;
  const incentives = getEVIncentives(vehicle);

  return (
    <VehicleContext.Provider value={vehicle}>
      <VehicleDetail>
        <StyledCard
          view={view}
          model={vehicle.model_name}
          hasIncentives={
            incentives.count > 0
            || vehicle.category == VehicleCategory.CERTIFIED
          }
        >
          {children}
        </StyledCard>
      </VehicleDetail>
    </VehicleContext.Provider>
  );
};

export default VehicleCardLayout;
